import React, { Component } from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"

import DesktopContainer from "~/components/DesktopContainer"
import SectionHeader from "~/components/Pages/SectionHeader"
import Spacer from "~/components/Spacer"
import DetailsTable from "./DetailsTable"

import PlainTextButton from "./PlainTextButton"
import WhiteButton from "~/components/traffic-tickets/steps/WhiteButton"
import NextIcon from "../../../public/static/images/svg/rightBlueArrow.svg"
import AutoDisputeToggle from "./AutoDisputeToggle"
import CommunicationsToggle from "./CommunicationsToggle"

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 60px;
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.background.main};
`

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const Split = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

@inject(all => ({
  nextStep: all.store.parkingFlow.flow.nextStep,
  previousStep: all.store.parkingFlow.flow.previousStep
}))
@observer
class ParkingTicketDetails extends Component {
  render() {
    return (
      <PageContainer>
        <DesktopContainer>
          <MainContainer>
            <SectionHeader
              title="Ticket Information"
              // text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eu varius ex."
            />
            <Spacer mobile={48} desktop={48} />
            <DetailsTable />
            <Spacer mobile={48} desktop={48} />
            <Split>
              <AutoDisputeToggle />
              <CommunicationsToggle />
            </Split>
            <Spacer mobile={72} desktop={72} />
            <ButtonRow>
              <ButtonContainer>
                <PlainTextButton
                  isMobile={this.props.isMobile}
                  text="Back"
                  onClick={this.props.previousStep}
                />
                <WhiteButton
                  image={NextIcon}
                  text="Next"
                  onClick={this.props.nextStep}
                />
              </ButtonContainer>
            </ButtonRow>
            <Spacer mobile={32} desktop={32} />
          </MainContainer>
        </DesktopContainer>
      </PageContainer>
    )
  }
}

export default ParkingTicketDetails
